export const mobileContent = 'Payment will be charged to your mobile bill.';

export const fundsProtectionContent = `Your funds are in a separate account but not protected if MrQ goes out of business. Learn more `;
